import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { translateIndexedName } from '../helpers/indexed-name.helper';

@Pipe({
  name: 'indexedName',
  standalone: false,
  pure: false,
})
export class IndexedNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  public transform(name: string | undefined | null): string {
    return translateIndexedName(name, (key) => this.translate.instant(key) as string);
  }
}
